module.exports = __webpack_public_path__ + "img/call.f7958fbe.svg";